import { render, staticRenderFns } from "./proofAPPService.vue?vue&type=template&id=51fabbbb&"
import script from "./proofAPPService.vue?vue&type=script&lang=js&"
export * from "./proofAPPService.vue?vue&type=script&lang=js&"
import style0 from "./proofAPPService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports